import * as React from "react";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import { Chat, Message } from "../../api/classes";
import {
  List,
  ListItem,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  Badge,
  Chip,
  Typography,
  Divider,
  Hidden
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import * as moment from "moment";
import "./scrollbar.css";
import Chats from "./chats";
import MessageDetail from "./detail";
import { RouteComponentProps } from "react-router";
import Loading from "../../components/loading";
import { DubitoSvc } from "src/api";

interface MessageDetailParams {
  id: string;
}
interface Props extends RouteComponentProps<MessageDetailParams> {
  chats: Chat[];
  messages: Message[];
  fetchChats: () => void;
  markAsRead: (sender_id: string) => void;
}
interface State {}
class Messages extends React.Component<Props, State> {
  state = {
    chat: this.props.chats && this.props.chats[0]
  };
  componentWillMount() {
    if (!this.props.chats) {
      this.props.fetchChats();
    } else {
      this.checkID(this.props);
    }
  }
  checkID(next: Props) {
    if (next.match.params.id) {
      this.setState({
        chat: next.chats.find(i => i.chatID === next.match.params.id)
      });
    } else {
      this.setState({ chat: next.chats[0] });
    }
  }
  componentWillReceiveProps(next: Props) {
    if (!this.props.chats && next.chats) {
      this.checkID(next);
    }
  }
  markMessagesAsRead = sender_id => {
    DubitoSvc.markMessagesAsRead({ sender_id: sender_id }).then(() => {
      this.props.markAsRead(sender_id);
    });
  };
  render() {
    if (!this.props.chats) {
      return <Loading />;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          maxHeight: "100%"
        }}
      >
        <Hidden smDown>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              maxHeight: "100%"
            }}
          >
            <div style={{ flex: 1, display: "flex", maxHeight: "100%" }}>
              <Chats
                onSelectChat={(chat: Chat) => {
                  this.props.history.push("/message/" + chat.chatID);

                  if (chat.unreads > 0) {
                    chat.unreads = 0;
                    this.markMessagesAsRead(chat.sender_id);
                  }
                  this.setState({ chat: chat });
                }}
                onSelectChatID={(id: string) => {
                  this.props.history.push("/message/" + id);
                  this.setState({ chat: undefined });
                }}
              />
            </div>
            <div style={{ flex: 5, display: "flex" }}>
              <MessageDetail
                chat={this.state.chat}
                chatID={this.props.match.params.id}
              />
            </div>
          </div>
        </Hidden>
        <Hidden mdUp implementation="js">
          <div style={{ flex: 1, display: "flex", width: "100%" }}>
            {this.props.match.params.id ? (
              <MessageDetail
                showBack
                onBack={() => this.props.history.goBack()}
                chat={this.state.chat}
                chatID={this.props.match.params.id}
              />
            ) : (
              <Chats
                onSelectChat={(chat: Chat) => {
                  this.props.history.push("/message/" + chat.chatID);
                  if (chat.unreads > 0) {
                    chat.unreads = 0;
                    this.markMessagesAsRead(chat.sender_id);
                  }
                  this.setState({ chat: chat });
                }}
              />
            )}
          </div>
        </Hidden>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    chats: state.cases.chats,
    messages: state.cases.messages
  }),
  dispatch => ({
    fetchChats: (): any => dispatch(actions.fetchChats()),
    markAsRead: (sender_id: string): any =>
      dispatch(actions.markAsRead(sender_id))
  })
)(Messages);



// WEBPACK FOOTER //
// ./src/pages/messages/index.tsx